import { qs, qsa } from 'music';
import initFormHandlers from '~/src/features/registration/init_form_handlers.js';
import addFieldShowHide from './add_field_show_hide.js';
import { validations, rulesList } from '~/src/features/registration/validation_rules.js';
import populateSelectOptions from '~/src/shared_ui/custom_elements/form_item/populate_select_options.js';
import '~/src/features/registration/account_new.scss';

window.addEventListener('DOMContentLoaded', () => {
  qsa('ua-form-item').forEach((item) => {
      item.addValidations(rulesList, validations);
  });
  qsa('.js-populate-options').forEach((select) => {
    populateSelectOptions(select);
  });

  addFieldShowHide();

  const theForm = qs('.js-register-form');
  const submitButton = qs('.js-create-account-btn', theForm);
  initFormHandlers(theForm, submitButton);
});
